import { Injectable, signal } from '@angular/core';
import { AppConstant } from '@app/app.constant';
import { LocalStorageService } from './local-storage.service';

export type ThemeMode = 'light' | 'dark';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private readonly lightClass = 'admin-theme-light';
    private readonly darkClass = 'admin-theme-dark';

    readonly mode = signal<ThemeMode>(this.getStoredMode());
    readonly isDark = signal(this.mode() === 'dark');

    constructor() {
        this.applyTheme(this.mode());
    }

    initialize(): void {
        this.applyTheme(this.mode());
    }

    setMode(mode: ThemeMode): void {
        this.mode.set(mode);
        this.isDark.set(mode === 'dark');
        LocalStorageService.setItem(AppConstant.LOCAL_STORAGE_KEYS.THEME_MODE, JSON.stringify(mode));
        this.applyTheme(mode);
    }

    toggleMode(): void {
        this.setMode(this.mode() === 'dark' ? 'light' : 'dark');
    }

    private getStoredMode(): ThemeMode {
        const storedMode = LocalStorageService.getItem(AppConstant.LOCAL_STORAGE_KEYS.THEME_MODE);
        return storedMode === 'dark' ? 'dark' : 'light';
    }

    private applyTheme(mode: ThemeMode): void {
        const root = document.documentElement;

        root.classList.toggle(this.darkClass, mode === 'dark');
        root.classList.toggle(this.lightClass, mode === 'light');
        root.style.colorScheme = mode;
    }
}
